export default __webpack_public_path__ + "media/images/landing-26-550x420-133a07cf764019b52d1182e6c22030c8.jpg";